import React, { useState, useEffect } from 'react';



function ConceptualDemoWarning() {

  const [isCollapsed, setIsCollapsed] = useState(false);

  // useEffect(() => {
  //   const savedState = sessionStorage.getItem('demoWarningCollapsed');
  //   if (savedState === 'true') {
  //     setIsCollapsed(true);
  //   }
  // }, []);

  const handleToggle = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    sessionStorage.setItem('demoWarningCollapsed', newState.toString());
  };

  // Nevermind lets hide the whole thing if collapsed.
  if (isCollapsed) {
    return null;
  }

  return (
    <div
      className="demo-warning"
      style={{
        display: 'block',
        width: '90%',
        maxWidth: '70vw',
        background: '#99AAFF',
        color: '#222',
        padding: isCollapsed ? '0.1rem 1rem' : '1rem',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '1rem',
        marginBottom: '1rem',
        textAlign: 'center',
        zIndex: 995,
        fontSize: '1.1rem',
        fontWeight: 'bold',
        paddingTop: isCollapsed ? "0.1rem" : "2rem",
        borderRadius: 5,
        cursor: 'pointer',
        position: 'relative', // Added for positioning the "X"
      }}
      onClick={handleToggle}
    >
      <div
        style={{
          position: 'absolute',
          top: '0.5rem',
          right: '0.5rem',
          fontSize: '1.5rem',
          fontWeight: 'bold',
          cursor: 'pointer',
          marginBotton: '2rem'
        }}
        onClick={(e) => {
          e.stopPropagation();
          setIsCollapsed(true);
          sessionStorage.setItem('demoWarningCollapsed', 'true');
        }}
      >
        ✖
      </div>
      {!isCollapsed && (
        <>
          Warning: This is not a real tool. It's a conceptual demo for a tool that may be built in the future.<br />
          {/* <button
            style={{
              background: '#2e275a',
              color: 'white',
              fontWeight: 'bold',
              border: 0,
              borderRadius: 6,
              padding: '1rem 2.5rem',
              fontSize: '1.1rem',
              cursor: 'pointer',
              margin: '1rem',
            }}
            onClick={(e) => {
              e.stopPropagation();
              window.location.href = 'https://forms.gle/WcKoMR28Pa8RSQuPA';
            }}
          >
            Sign Up for Early Access
          </button> */}
        </>
      )}
    </div>
  );
}

export default ConceptualDemoWarning;